import PodcastMediaTabs, { PodcastMediaTabsProps } from './PodcastMediaTabs';

export default PodcastMediaTabs;
export type { PodcastMediaTabsProps };
